import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => {
  return (
    <div id="not-found" className="page-wrapper">
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backgroundColor: "#f8f9fa",
        }}
      >
        <div
          className="container"
          style={{
            textAlign: "center",
            padding: "40px 20px",
          }}
        >
          <h1
            style={{
              fontSize: "120px",
              fontWeight: "bold",
              color: "#e74c3c",
              margin: "0",
              lineHeight: "1",
            }}
          >
            404
          </h1>
          <h2
            style={{
              fontSize: "36px",
              marginTop: "20px",
              marginBottom: "20px",
              color: "#333",
            }}
          >
            Page Not Found
          </h2>
          <p
            style={{
              fontSize: "18px",
              color: "#666",
              marginBottom: "30px",
              maxWidth: "600px",
              margin: "0 auto 30px",
            }}
          >
            We're sorry, but the page you're looking for could not be found.
            The page may have been removed, had its name changed, or is
            temporarily unavailable. Please check the URL or return to the
            homepage.
          </p>
          <div style={{ marginTop: "40px" }}>
            <Link
              to="/"
              className="btn btn-custom btn-lg"
              style={{
                display: "inline-block",
                padding: "12px 30px",
                backgroundColor: "#2196F3",
                color: "white",
                textDecoration: "none",
                borderRadius: "5px",
                cursor: "pointer",
              }}
            >
              Return to Home
            </Link>
          </div>

          {/* Additional helpful links */}
          {/* <div
            style={{
              marginTop: "60px",
              padding: "30px",
              backgroundColor: "white",
              borderRadius: "10px",
              boxShadow: "0 2px 10px rgba(0,0,0,0.1)",
            }}
          >
            <h3 style={{ marginTop: "0", color: "#333" }}>
              Helpful Links
            </h3>
            <nav>
              <ul
                style={{
                  listStyle: "none",
                  padding: "0",
                  display: "flex",
                  flexWrap: "wrap",
                  justifyContent: "center",
                  gap: "20px",
                }}
              >
                <li>
                  <Link to="/" style={{ color: "#2196F3", textDecoration: "none" }}>
                    Home
                  </Link>
                </li>
                <li>
                  <a
                    href="#services"
                    style={{ color: "#2196F3", textDecoration: "none" }}
                  >
                    Services
                  </a>
                </li>
                <li>
                  <a
                    href="#portfolio"
                    style={{ color: "#2196F3", textDecoration: "none" }}
                  >
                    Projects
                  </a>
                </li>
                <li>
                  <a
                    href="#contact"
                    style={{ color: "#2196F3", textDecoration: "none" }}
                  >
                    Contact
                  </a>
                </li>
              </ul>
            </nav>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default NotFound;
